module.exports = __webpack_public_path__ + "img/0445_09.d25aac07.jpg";